<template>
    <v-form ref="formDados"
        lazy-validation
        v-model="formValid">
        <div>
            <v-dialog width="40%" v-model="processo.show" :fullscreen="$vuetify.breakpoint.xsOnly">
                <v-card>
                    <v-card-title class="text-h6 grey lighten-2">
                        Atribuir processo {{ processo.numero }}/{{ processo.ano }}
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="[processo.show = false]"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row class="mt-2">
                            <v-col
                                cols="12"
                                sm="12"
                                xs="12"
                            >
                                <v-autocomplete
                                    :items="processo.usuarios"
                                    item-text="name"
                                    item-value="id"
                                    v-model="processo.usuario_id_atribuicao"
                                    required
                                    :rules="[rules.required]"
                                    label="Selecione o usuário a atribuir"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col
                                cols="12"
                                sm="12"
                                xs="12"
                            >
                                <v-text-field
                                    v-model="processo.observacao"
                                    label="Observação"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="accent"
                            dense
                            @click="[atribuirProcesso()]"
                        >
                            Atribuir processo
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-form>
</template>
<script>
    export default{
    name: 'atribuir-processo',
        props:{
            processo:{
                id: Number,
                ano: Number,
                numero: Number,
                usuario_id_atribuicao: String,
                usuario_id_registro: String,
                setor_id: String,
                observacao: String,
                show: Boolean,
                usuarios: Array,
            },

        },
        data: () => ({
            formValid: false,
            rules: {
                required: value => !!value || 'O preenchimento é obrigatório',
            },
        }),
        methods: {
            atribuirProcesso () {
                if (!this.$refs.formDados.validate())
                    return false
                this.$emit('processoAtribuir', {
                    processo: this.processo,
                })
                this.processo.show = false
            },
            getUserSetor(value){
                this.axios.get(`gerencial/users/sector/${value.setor_id_atual}`).then((res) => {
                    const usuarios = res.data; 
                    for(var j = 0 ; j < usuarios.length; j++){
                        if (usuarios[j].active)
                            this.processo.usuarios.push(usuarios[j]);
                    }
                }).catch(e => {
                    this.snackbar = {
                        ...this.snackbar,
                        show: true,
                        text: e.response.data[Object.keys(e.response.data)[0]][0],
                        color: 'red',
                    }
                })
            }
        },
        mounted () {
            this.$refs.formDados.validate()
        }
    }
</script>